module.exports = __webpack_public_path__ + "img/ico-5-active.840eecaa.svg";